import React, { useState, useEffect } from "react";
import Logo from "../CoinHeatMap.png";
import { Link } from "react-router-dom";
import { useAccount, useDisconnect } from 'wagmi';
import SwitchNetwork from './SwitchNetworks';
import { web3Modal } from "../index"; // Import the web3Modal instance
import ConnectButton from "./ConnectButton"; // Import the ConnectButton component

function Header({ provider }) {
  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const [isDisconnecting, setIsDisconnecting] = useState(false);
  const [isOpen, setIsOpen] = useState(false); // State for responsive menu

  const handleDisconnect = async () => {
    setIsDisconnecting(true);
    console.log("Attempting to disconnect...");
    try {
      await disconnect();
      localStorage.clear();
      sessionStorage.clear();
      window.location.reload();
    } catch (error) {
      console.error("Failed to disconnect", error);
    } finally {
      setIsDisconnecting(false);
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  // Close the menu when resizing back to fullscreen
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isOpen) {
        setIsOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isOpen]);

  return (
    <header>
      <div className="leftH">
        <a href="https://coinheatmap.com">
          <img src={Logo} alt="logo" className="logo" 
            style={{ width: '175px', height: 'auto' }}
          />
        </a>
        <button className="menuToggle" onClick={toggleMenu}>
          ☰
        </button>
        <div className={`navLinks ${isOpen ? 'open' : ''}`}>
          <Link to="/" className="link" onClick={closeMenu}>
            <div className="headerItem">Swap</div>
          </Link>
          <Link to="/balances" className="link" onClick={closeMenu}>
            <div className="headerItem">Balances</div>
          </Link>
          {/* Show Connect & Switch Network buttons on smaller screens */}
          <div className="mobileRightH">
            <SwitchNetwork provider={provider} />
            <div className="connectButton">
              {isConnected && address ? (
                <>
                  <span>{address.slice(0, 4) + "..." + address.slice(-4)}</span>
                  <button
                    className="disconnectButton"
                    onClick={handleDisconnect}
                    disabled={isDisconnecting}
                  >
                    {isDisconnecting ? 'Disconnecting...' : 'Disconnect'}
                  </button>
                </>
              ) : (
                <ConnectButton />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Only show on larger screens */}
      <div className="rightH">
        <SwitchNetwork provider={provider} />
        <div className="connectButton">
          {isConnected && address ? (
            <>
              <span>{address.slice(0, 4) + "..." + address.slice(-4)}</span>
              <button
                className="disconnectButton"
                onClick={handleDisconnect}
                disabled={isDisconnecting}
              >
                {isDisconnecting ? 'Disconnecting...' : 'Disconnect'}
              </button>
            </>
          ) : (
            <ConnectButton />
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
